import { useRef as h, useState as S, useEffect as T, useMemo as E, useCallback as D } from "react";
import { subscribe as b, publish as d, unsubscribe as f } from "@wh/message-bus";
const O = "OB_OU", g = (r = "") => r.replace(O, ""), _ = {
  FIXED_ODDS: "L",
  STARTING_PRICE: "S"
};
async function F(r, e = { priceType: "FIXED_ODDS", eachWay: !1 }) {
  const t = {
    selectionId: g(r),
    priceType: _[(e == null ? void 0 : e.priceType) ?? "FIXED_ODDS"],
    eachWay: (e == null ? void 0 : e.eachWay) ?? !1,
    analytics: e == null ? void 0 : e.analytics
  };
  return new Promise((o, s) => {
    const a = b(
      "wh.sports.betslip.headless.selections",
      (n, l) => {
        t.selectionId in l && i();
      }
    );
    d("betslip.leg.add", t);
    function i() {
      f(a), o();
    }
    setTimeout(() => {
      f(a), s(new Error("Timeout"));
    }, 5e3);
  });
}
async function I(r) {
  const e = g(r);
  return new Promise((t, o) => {
    const s = b(
      "wh.sports.betslip.headless.selections",
      (i, n) => {
        e in n || a();
      }
    );
    d("betslip.leg.remove", {
      id: e
    });
    function a() {
      f(s), t();
    }
    setTimeout(() => {
      f(s), o(new Error("Timeout"));
    }, 5e3);
  });
}
function R(r) {
  const e = h(r);
  e.current = r;
  const [t, o] = S({});
  return T(() => {
    const s = b(
      "wh.sports.betslip.headless.selections",
      (a, i) => {
        if (i == null || typeof i != "object")
          return;
        const n = {};
        for (const l of e.current)
          n[l] = g(l) in i;
        JSON.stringify(n) !== JSON.stringify(i) && o(n);
      }
    );
    return () => {
      f(s);
    };
  }, []), t;
}
function B(r, e = { priceType: "FIXED_ODDS", eachWay: !1 }) {
  const [t, o] = S(!1), [s, a] = S(!1), [i, n] = S(null), p = R(
    E(() => [r], [r])
  )[r] ?? !1, y = h(!1), w = D(async () => {
    if (!(t || s) && !y.current)
      if (y.current = !0, p) {
        a(!0);
        try {
          await I(r), n(null);
        } catch (c) {
          const m = typeof c == "object" && c != null && "message" in c ? c.message : "Unknown error", u = new Error(
            `Failed to remove selection from betslip: ${m}`
          );
          if (n(u), e.throwOnError)
            throw u;
        } finally {
          a(!1), y.current = !1;
        }
      } else {
        o(!0);
        try {
          await F(r, {
            priceType: e.priceType,
            eachWay: e.eachWay,
            analytics: e.analytics
          }), n(null);
        } catch (c) {
          const m = typeof c == "object" && c != null && "message" in c ? c.message : "Unknown error", u = new Error(
            `Failed to add selection to betslip: ${m}`
          );
          if (n(u), e.throwOnError)
            throw u;
        } finally {
          o(!1), y.current = !1;
        }
      }
  }, [
    t,
    s,
    p,
    r,
    e.analytics,
    e.eachWay,
    e.priceType
  ]);
  return { isAdded: p, isAdding: t, isRemoving: s, error: i, toggle: w };
}
export {
  B as useBetslipSelectionManager,
  R as useBetslipSelectionsSubscription
};
